import { createContext } from 'react';
import type { StageAtoms } from './types/stage-atoms';
export const StageAtomsContext = createContext<StageAtoms | null>(null);